import { IApplicationState } from '../../types/redux';
import { getHouses } from '../newbuilding/getHouses';
import { getSelectedHouseId } from './getSelectedHouseId';

export function isHouseNameVisible(state: IApplicationState) {
  return getHouses(state).length > 1 && !getSelectedHouseId(state);
}
